module.exports = __webpack_public_path__ + "img/platform.2da2c1ff.png";